import { css, html, LitElement, nothing, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";
import "../dui/markdown/dui-markdown.ts";
import "../dui/scroll-area/dui-scroll-area.ts";

const hostStyles = css`
  :host {
    display: block;
  }
`;

const componentStyles = css`
  .NotePreview {
    font-size: var(--font-size-sm);

    /* Compact overrides — these pierce into dui-markdown's shadow DOM */
    --font-size-2xl: var(--font-size-xs);
    --font-size-lg: var(--font-size-xs);
    --font-size-md: var(--font-size-xs);
    --font-size-base: var(--font-size-xs);
    --space-6: var(--space-2);
    --space-8: var(--space-3);
  }

  .NotePreviewContent {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }

  .title {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    letter-spacing: var(--letter-spacing-tight);
    color: var(--muted-foreground);
  }
`;

@customElement("note-preview")
export class NotePreviewElement extends LitElement {
  static override styles = [base, hostStyles, componentStyles];

  @property()
  accessor heading: string | undefined = undefined;

  @property()
  accessor value: string = "";

  override render(): TemplateResult {
    return html`
      <div class="NotePreview" part="root">
        <dui-scroll-area max-height="var(--space-48)">
          <div class="NotePreviewContent">
            ${this.heading
              ? html`<strong class="title">${this.heading}</strong>`
              : nothing}
            <dui-markdown .value="${this.value}"></dui-markdown>
          </div>
        </dui-scroll-area>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "note-preview": NotePreviewElement;
  }
}
